import React from "react";
import PropTypes from "prop-types";
import { Grid, Row, Col, Nav } from "react-bootstrap";
import { Switch, Route, Redirect } from "react-router";
import { injectIntl, FormattedMessage } from "react-intl";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import isIexplorer from "is-iexplorer";

import GrafikenContainer from "./GrafikenContainer";
import GrafikenInfoPanelContainer from "./GrafikenInfoPanelContainer";
import LastLeerlaufChartContainer from "./LastLeerlaufChartContainer";
import LastLeerlaufTabelleContainer from "./LastLeerlaufTabelleContainer";
import MotorstartsChartContainer from "./MotorstartsChartContainer";
import MotorstartsTabelleContainer from "./MotorstartsTabelleContainer";
import SpezifischeLeistungsaufnahmeChartContainer from "./SpezifischeLeistungsaufnahmeChartContainer";
import SpezifischeLeistungsaufnahmeTabelleContainer from "./SpezifischeLeistungsaufnahmeTabelleContainer";
import EnergieverbrauchChartContainer from "./EnergieverbrauchChartContainer";
import EnergieverbrauchTabelleContainer from "./EnergieverbrauchTabelleContainer";
/*import LogTabelleContainer from "./LogTabelleContainer";*/
import DailyValuesInfoPanelContainer from "./DailyValuesInfoPanelContainer";
import DatenTabellenContianer from "./DatenTabellenContainer"

import AlmigLink from "../grundelemente/AlmigLink";
import BreadcrumbContainer from "../grundelemente/BreadcrumbContainer";
import OnlyTimeInfoPanel from "../grundelemente/OnlyTimeInfoPanel";

import "./Analysen.css";

class Analysen extends React.Component {

	static propTypes = {
		print: PropTypes.object.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.printRequest = this.printRequest.bind(this);
	}

	printRequest() {
		let content = document.getElementsByClassName("printableAlmigItem");
		if (content.length > 0) {
			let payload = content[0];
			html2canvas(payload).then(function(canvas) {
				const imgData = canvas.toDataURL('image/png');
				/*
				 * settings sicherheitshalber aufbereiten!
				 */
				let size = this.props.print.paper_size.toLowerCase();
				let orientation = this.props.print.orientation.toLowerCase();

				let pdf;
				try {
					pdf = new jsPDF(
						orientation,
						"mm",
						size);
				}
				catch (e) {
					/*
					 * wenn irgendwas trotzdem nicht klappt, dann interne defaults
					 * con jspdf verwenden.
					 */
					pdf = new jsPDF();
				}
				let m_l = parseInt(this.props.print.left_margin, 10);
				let m_t = parseInt(this.props.print.top_margin, 10);
				/*
				let m_r = parseInt(this.props.print.right_margin, 10);
				let m_b = parseInt(this.props.print.bottom_margin, 10);
				let width = pdf.internal.pageSize.getWidth();
				let height = pdf.internal.pageSize.getHeight();
				width -= (m_l + m_r);
				height -= (m_t + m_b);
				*/
				pdf.addImage(
					imgData,
					'PNG',
					m_l,
					m_t);
				pdf.save("Analyse.pdf"); 
			}.bind(this));	// der bind schaut doff aus, brauchen wir aber wegen den settings!
		}
		else {
			console.log("found nothing to print, how sad!");
		}
	}

	renderIENav() {
		if (!isIexplorer) {
			return <React.Fragment>
				<AlmigLink exact to="/analysis/graphics" className="UntenRandlos" />
				<Nav stacked className="Navispalte">
					<AlmigLink to="/analysis/graphics/load_non-load_ratio" />
					<AlmigLink to="/analysis/graphics/motor_starts" />
					<AlmigLink to="/analysis/graphics/specific_power" />
					<AlmigLink to="/analysis/graphics/energy_consumption" />
				</Nav>
			</React.Fragment>
		}
		return <React.Fragment />
	}

	renderIESwitch() {
		if (!isIexplorer) {
			return <Switch>
				<Route path="/analysis/graphics/load_non-load_ratio"
						component={LastLeerlaufChartContainer} />
				<Route path="/analysis/graphics/motor_starts"
						component={MotorstartsChartContainer} />
				<Route path="/analysis/graphics/specific_power"
						component={SpezifischeLeistungsaufnahmeChartContainer} />
				<Route path="/analysis/graphics/energy_consumption"
						component={EnergieverbrauchChartContainer} />
				<Route path="/analysis/graphics" component={GrafikenContainer} />
				<Route path="/analysis/data_table/load_non-load_ratio"
						component={LastLeerlaufTabelleContainer} />
				<Route path="/analysis/data_table/motor_starts"
						component={MotorstartsTabelleContainer} />
				<Route path="/analysis/data_table/specific_power"
						component={SpezifischeLeistungsaufnahmeTabelleContainer} />
				<Route path="/analysis/data_table/energy_consumption"
						component={EnergieverbrauchTabelleContainer} />
				<Route path="/analysis/data_table"
						component={DatenTabellenContianer} />
				<Redirect exact path="/analysis" to="/analysis/graphics" />
			</Switch>
		}
		return <Switch>
			<Route path="/analysis/data_table/load_non-load_ratio"
					component={LastLeerlaufTabelleContainer} />
			<Route path="/analysis/data_table/motor_starts"
					component={MotorstartsTabelleContainer} />
			<Route path="/analysis/data_table/specific_power"
					component={SpezifischeLeistungsaufnahmeTabelleContainer} />
			<Route path="/analysis/data_table/energy_consumption"
					component={EnergieverbrauchTabelleContainer} />
			<Redirect exact path="/analysis/data_table"
					to="/analysis/data_table/load_non-load_ratio" />
			<Redirect exact path="/analysis" to="/analysis/data_table" />
		</Switch>;
	}

	render() {
		return (
			<Grid className="Analysen">
				<Row>
					<Col xs={12}>
						<BreadcrumbContainer />
					</Col>
				</Row>
				<Row> {/*siehe CSS: className="match-my-cols"*/}
					<Col sm={12} md={3}>
						<Nav stacked className="Navispalte">
							{this.renderIENav.bind(this)()}
							<AlmigLink exact to="/analysis/data_table" className="UntenRandlos" />
							<Nav stacked className="Navispalte">
								<AlmigLink to="/analysis/data_table/load_non-load_ratio" />
								<AlmigLink to="/analysis/data_table/motor_starts" />
								<AlmigLink to="/analysis/data_table/specific_power" />
								<AlmigLink to="/analysis/data_table/energy_consumption" />
							</Nav>
						</Nav>
					</Col>
					<Col sm={12} md={6} className="Mittelspalte">
						{this.renderIESwitch.bind(this)()}
					</Col>
					<Col sm={12} md={3}>
						<Switch>
							<Route path="/analysis/graphics/*"
								render={(props) => <DailyValuesInfoPanelContainer {...props} printRequest={this.printRequest} /> }
							/>
							<Route path="/analysis/data_table/*"
								render={(props) => <DailyValuesInfoPanelContainer {...props} printRequest={this.printRequest} /> }
							/>
							<Route path="/analysis/graphics"
								render={(props) => <GrafikenInfoPanelContainer {...props} printRequest={this.printRequest} /> }
							/>
							<Route path="/analysis/data_table"
								component={OnlyTimeInfoPanel} />
						</Switch>
					</Col>
				</Row>
				{ isIexplorer ?
					<Row className="IE-Warning">
						<FormattedMessage id="IE Warning"/>
					</Row>
					:
					<React.Fragment />
				}
			</Grid>
		);
	}
}

export default injectIntl(Analysen);